import Vue from 'vue'
import TipComponent from './index.vue'

const Message = {}
let comShow = false // 存储loading显示状态
let loadingNode = null // 存储loading节点元素
const TipConstructor = Vue.extend(TipComponent)

Message.install = function (Vue) {
  Vue.prototype.$wsMessage = function (content, closeAble,center,cb) {
    if(content&&content.toString().indexOf('network')>-1){
    content = this.globalConfig && this.globalConfig.translation&&this.globalConfig.translation[content]? this.globalConfig.translation[content]:"Network connection error, please try again later";
    }
    if(content&&content.toString().indexOf('serverbusy')>-1){
      content = this.globalConfig && this.globalConfig.translation&&this.globalConfig.translation['TOAST_SERVER_BUSY']? this.globalConfig.translation['TOAST_SERVER_BUSY']:"Server busy, please try again later";
      }
    // if (show) {
      // 如果loading还在，则不再执行
      // if (comShow) return;
      
      if(loadingNode){
        if(typeof(closeAble)==='number'){
          loadingNode.closeAble = false
        }else{
          loadingNode.closeAble = closeAble
        }
        loadingNode.content = content
        loadingNode.center = center
      }else{
        if(typeof(closeAble)==='number'){
          loadingNode = new TipConstructor({
            data(){
              return {
                closeAble:false,
                message:content,
                center:center,
                cb:cb
              }
            }
          })
        }else{
          loadingNode = new TipConstructor({
            data(){
              return {
                closeAble:closeAble,
                message:content,
                center:center,
                cb:cb
              }
            }
          })
        }
        
        loadingNode.$mount() // 挂在实例，为了获取下面的loadingNode.$el
        document.body.appendChild(loadingNode.$el)
      }
      loadingNode.show = true
      if(typeof(closeAble)==='number'){
        loadingNode.delayHide(closeAble)
      }
      // loadingNode.show = comShow = true
    // } else {
    //   if(loadingNode){
    //     loadingNode.show = comShow = false
    //   }
    // }
  };
}
// Message.changeShow=(show)=>{
//   comShow=show
// }
export default Message


// WEBPACK FOOTER //
// ./src/components/wsMessage/index.js